import { FormikHelpers } from 'formik';

import { ConfiguracaoMinimo } from '../types';

import { useFormContext } from 'context/FormContext';
import { useLoaderContext } from 'context/LoaderContext';
import { useFormMutation } from 'mutations/useFormMutation';

export function useMutateConfiguracaoMinimo() {
    const { setContent } = useFormContext();
    const { mutate } = useFormMutation();
    const { setLoader } = useLoaderContext();

    const onSubmit = (values: ConfiguracaoMinimo, formik: FormikHelpers<ConfiguracaoMinimo>) => {
        setLoader(true);

        mutate(
            {
                url: '/gestao/configuracaogeralpedidominimo',
                formData: values,
                formik,
            },
            {
                onSuccess: (response: any) => setContent(response.data.data),
                onSettled: () => setLoader(false),
            },
        );
    };

    return { onSubmit };
}
